interface ThreeDotsIconProps {
  className?: string;
}

export const ThreeDotsIcon = ({ className = "w-5 h-5" }: ThreeDotsIconProps) => {
  return (
    <svg 
      className={className} 
      fill="currentColor" 
      viewBox="0 0 20 20"
    >
      <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
    </svg>
  );
};
